export default __webpack_public_path__ + "static/media/About-Header.5f45dd39.png";